import type { Partner } from "@expert/shared-types";

import type { Customer } from "../../../../../types";

function isExpertUniversitySesssion(sessionId: string): boolean {
    return sessionId.includes("test-training");
}

export interface BuildPartnerToolUrlParams {
    partner: Partner;
    partnerToolUrl: string | undefined;
    isDevMode: boolean;
    customerName: string;
    formattedMdn: string;
    authorizedUsers: Customer[];
    sessionId?: string;
    determineVerificationStatus: (name: string, mdn: string, users: Customer[]) => number;
}

export interface PartnerToolUrlResult {
    shouldOpen: boolean;
    url: string | null;
}

/**
 * Determines if the partner tool should be opened and builds the URL if applicable.
 */
export function buildPartnerToolUrl(params: BuildPartnerToolUrlParams): PartnerToolUrlResult {
    const {
        partner,
        partnerToolUrl,
        isDevMode,
        customerName,
        formattedMdn,
        authorizedUsers,
        sessionId,
        determineVerificationStatus,
    } = params;

    if (sessionId && isExpertUniversitySesssion(sessionId)) {
        return { shouldOpen: false, url: null };
    }

    if (isDevMode || !partnerToolUrl) {
        return { shouldOpen: false, url: null };
    }

    if (partner === "verizon") {
        const verificationStatus = determineVerificationStatus(customerName, formattedMdn, authorizedUsers);
        return {
            shouldOpen: true,
            url: `${partnerToolUrl}${verificationStatus}&mdnSearched=${formattedMdn}`,
        };
    }

    return { shouldOpen: true, url: partnerToolUrl };
}
